import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import Highcharts from "highcharts";
import "highcharts/modules/accessibility";
import "highcharts/modules/exporting";
import "highcharts/modules/export-data";
import "highcharts/modules/series-label";

class Chart extends React.Component<any, any> {
  componentDidMount() {
    setTimeout(this.renderChart, 0);
    /* this.renderChart(); */
  }

  componentDidUpdate(_prevProps: any, _prevState: any) {
    this.renderChart();
  }

  renderChart = () => {
    const {
      data: { from, hour, logs, show_activity_chart },
    } = this.props;


    if (!show_activity_chart) return

    const data = Array.apply(null, Array(25)).map((_: any, i: number) =>
      i <= hour ? 0 : null,
    );
    logs.forEach((log: string) => {
      data[parseInt(log.substring(11, 13))] += 1;
    });

    // @ts-ignore
    Highcharts.chart("container", {
      title: { text: "" },
      legend: { enabled: false },
      xAxis: { title: { text: "" }, type: "datetime" },
      yAxis: { title: { text: "" } },
      series: [
        {
          name: "",
          pointStart: moment(from).utc().startOf("day").valueOf(),
          pointInterval: 1 * 60 * 60 * 1000,
          data,
        },
      ],
    });
  };

  render() {
    return (
      <div className="row">
        <div className="col-xs-12">
          <figure className="highcharts-figure" style={{ width: "100%" }}>
            <div id="container" />
          </figure>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  data: state.live.chart,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Chart);
